import { useEffect, useState } from "react";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useDispatch, useSelector } from "react-redux";
import CustomPopupForm from "../../../../component/customPopupModel";
import { useNavigate } from "react-router-dom";
import { formatServiceType } from "../../../../utils/customerHealperFunctions";
import {
  setOrderFlow,
  setSelectedService,
  setSelectedShop,
} from "../../../../Redux/Slices/customerSlice";
import StoreCard from "../../components/storeCard";
import { cardData } from "../../../../constants/shopDetails";
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../../../../assets/animation/notFount.json";


export default function Favourite() {
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [shop, setShop] = useState();
  const [favorite, setFavorite] = useState([]);
  const [offeredServices, setOfferedService] = useState([]);

  useEffect(() => {
    fetchFavorite();
  }, []);

  const fetchFavorite = () => {
    axiosInstance
      .get(`/customer/store/favouriteStores/${userId}`)
      .then((res) => {
        const rawData = res?.data?.data;
        const mappedShops = rawData?.map((shop) => {
          const today = new Date().toLocaleDateString("en-US", {
            weekday: "long",
          });
          const todayHours = shop?.store_hours?.[today] || "null";
          const shopImageDoc = shop?.uploadDoc?.find(
            (doc) => doc.name === "shop_image"
          );
          const image = shopImageDoc ? shopImageDoc.fileUrl : null;
          const services = (shop?.services || []).map((service) =>
            formatServiceType(service.serviceType)
          );
          return {
            id: shop?.id,
            title: shop?.storeName,
            time: todayHours,
            status: shop?.storeStatus ? "Open" : "Closed",
            services: services,
            rating: 3,
            image,
            isFavorite: true,
          };
        });
        setFavorite(mappedShops);
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const handleClose = () => setOpen(false);

  const handleSelectService = (service) => {
    setOpen(false);
    dispatch(setSelectedService(service));
    dispatch(setSelectedShop(shop));
    dispatch(setOrderFlow("shop"));
    navigate("/pickup-details");
  };

  return (
    <div className="w-full ">
      <h2 className="text-2xl font-[600] mb-3">
        Favourite <span className="text-[#008ECC]">Laundry</span>
      </h2>

      {favorite.length > 0 ? (
        <div className="flex flex-wrap justify-start gap-6 pt-2 pb-4 items-stretch h-[310px] md:h-[410px]">
          {favorite?.map((laundry, index) => (
            <div className="min-w-[250px] max-w-[250px] md:min-w-[300px] md:max-w-[300px]">
                          <StoreCard
              laundry={laundry}
              index={index}
              handleOrder={() => {
                setOfferedService(laundry.services);
                setShop(laundry);
                setOpen(true);
              }}
            />
            </div>

          ))}
        </div>
      ) : (
        <div className="flex flex-col bg-white items-center justify-center py-10 text-gray-500">
          <Player
            autoplay
            loop
            src={notFound}
            style={{ height: "200px", width: "200px" }}
          />
          <p className="text-center text-sm md:text-base">No orders found</p>
        </div>
      )}

      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType="service-selection"
        onSubmit={handleSelectService}
        dialogDetails={{
          selected_services: offeredServices,
        }}
      />
    </div>
  );
}
